import { createTheme } from "@mui/material";
const breakpoints = createTheme({
  breakpoints: {
    values: {
      xs: 425,
      sm: 768,
      md: 1024,
      lg: 1330,
      xl: 1980,
    },
  },
});
export const theme = createTheme({
  palette: {
    primary: {
      main: "#003063",
    },
    secondary: {
      main: "#f6ab22",
    },
    secondaryBlue: {
      main: "#0074c8",
    },
    error: {
      main: "#de3d35",
    },
    success: {
      main: "#73c21e",
    },
  },
  typography: {
    fontFamily: 'proxima-nova, sans-serif',
    h1: {},
    h2: {},
    h3: {},
    h4: {},
    h5: {},
    h6: {},
    body1: {
      fontFamily: "proxima-nova, sans-serif",
      fontWeight: 400,
      fontSize: "20px",
      lineHeight: "24px",
      fontStyle: "normal",
      [breakpoints.breakpoints.down("sm")]: {
        fontSize: "14px",
        lineHeight: "20px",
      },
      [breakpoints.breakpoints.up("md")]: {
        fontSize: "16px",
        lineHeight: "24px",
      },
      [breakpoints.breakpoints.up("lg")]: {
        fontSize: "20px",
        lineHeight: "24px",
      },
    },
    body2: {
      fontFamily: "proxima-nova, sans-serif",
      fontWeight: 400,
      fontSize: "16px",
      fontStyle: "normal",
      [breakpoints.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
      [breakpoints.breakpoints.up("md")]: {
        fontSize: "16px",
      },
      [breakpoints.breakpoints.up("lg")]: {
        fontSize: "16px",
      },
    },
    body3: {
      fontFamily: "proxima-nova, sans-serif",
      fontWeight: 400,
      fontSize: "16px",
      fontStyle: "normal",
      [breakpoints.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
      [breakpoints.breakpoints.up("md")]: {
        fontSize: "16px",
      },
      [breakpoints.breakpoints.up("lg")]: {
        fontSize: "16px",
      },
    },
    subtitle1: {

    },
    subtitle2: {},
    caption: {
        fontFamily: "proxima-nova, sans-serif",
        fontWeight: 400,
        fontSize: "12px",
        fontStyle: "normal",
        [breakpoints.breakpoints.down("sm")]: {
          fontSize: "10px",
        },
        [breakpoints.breakpoints.up("md")]: {
          fontSize: "12px",
        },
        [breakpoints.breakpoints.up("lg")]: {
          fontSize: "12px",
        },
    },
    formLabel: {
      fontFamily: "proxima-nova, sans-serif",
      fontWeight: 700,
      fontSize: "12px",
      lineHeight: "15px",
      textTransform: "uppercase",
      color: "#555555",
      fontStyle: "normal",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiChip: {
      variants: [
        {
          props: { color: "success", variant: "filled" },
          style: {
            color: "#fff",
            "& .MuiChip-icon": { color: "#fff" },
            "& .MuiChip-deleteIcon": { color: "#fff" },
          },
        },
      ],
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "medium",
        fullWidth: true,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "15px",
          fontWeight: 400,
          lineHeight: 1.5,
          color: "#212529",
          backgroundColor: "#fff",
          borderRadius: "0.375rem",
          transition: "border-color .15s ease-in-out",

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ced4da",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#80bdff",
            borderWidth: 1,
          },
          "& input::placeholder": {
            color: "#6c757d",
            opacity: 1,
          },
          "& input": {
            padding: "0.375rem 0.75rem",
          },
        },
        notchedOutline: {
          top: 0,
          border: "1px solid #dee2e6",
          borderRadius: "0.375rem",
          legend: {
            display: "none",
          },
        },
        input: {
          padding: "0.375rem 0.75rem",
          height: "calc(1.5em + 0.75rem + 2px)",
          fontSize: "15px",
        },
      },
    },
    // Force 15px on every input / textarea / select across the app.
    // Covers OutlinedInput, FilledInput, Input, and Select via the shared base.
    MuiInputBase: {
      styleOverrides: {
        root: { fontSize: "15px" , // If you use 'outlined' variant, this stops the border line from breaking
          '& legend': { display: 'none' }, 
        },
        input: { fontSize: "15px" },
        
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: { fontSize: "15px" },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          // Reset the display and force it above the input
          display: 'block !important', 
          position: 'relative',
          transform: 'none !important', // Stops the label from floating/scaling
          transformOrigin: 'top left',
          marginBottom: '4px',          // Adds spacing between label and input box
          fontSize: '15px!important',             // Adjust font size as needed
          fontWeight: 600
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          fontSize: "0.875rem",
        },
      },
    },
    MuiCircularProgress: {},
    MuiSkeleton: {},
    MuiModal: {},
  },
  breakpoints: {
    values: {
      xs: 425,
      sm: 768,
      md: 1024,
      lg: 1330,
      xl: 1980,
    },
  },
});
